<template>
<section class="course__area pt-50 pb-60">
    <div class="container">
        <div class="row">
            <div class="col-xxl-6">
                <div class="section__title-wrapper text-start mb-60">
                <h2 class="section__title">
                 <span class="yellow-bg yellow-bg-big">{{ $t('actions.course') }} <img src="../../assets/img/shape/yellow-bg.png" alt=""></span></h2>
                <p>{{ $t('actions.courseTitle') }} {{kurslar?.results?.length}} {{ $t('actions.courseTitle1') }}.</p>
                </div>
            </div>
        </div>
        <div class="row px-4">
            <div v-for="(blog, index) in kurslar?.results?.slice(0, 6)" :key="index" 
            class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                <div class="blog__item white-bg mb-30 transition-3 fix">
                <div class="blog__thumb w-img fix">
                    <a :href="blog.link" target="_blank">
                        <img height="230" :src="blog.image" alt="">
                    </a>
                </div>
                <div class="blog__content">
                    <div class="blog__tag">
                        <a href="#" :style="getBadgeStyle(blog.yonalishi)">{{blog.yonalishi}}</a>
                    </div>
                    <h3 class="blog__title" style="height:80px; font-size: 18px; font-weight: 600; margin-bottom: 0;">
                        <a :href="blog.link" target="_blank">
                            {{ 
                        getName({
                          nameUz: blog?.title_uz ?? '',
                          nameLt: blog?.title ?? '',
                          nameRu: blog?.title_ru ?? '',
                          nameEn: blog?.title_en ?? '',
                        })
                      }}
                        </a>
                    </h3>

                    <div class="blog__meta d-flex align-items-center justify-content-between">
                        <div class="blog__date d-flex align-items-center">
                            <i class="fal fa-clock"></i>
                            <span>{{blog.created_at?.slice(0, 10) + ', ' + blog.created_at?.slice(11, 16)}}</span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
          <div class="d-flex justify-content-end">
            <button @click="$router.push('/courses')" class="e-btn e-btn-2" name="apply_coupon" type="submit">{{ $t('actions.detail') }}</button>
          </div>
    </div>
</section>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import BlogMixin from '../../mixins/blogMixin';
export default {
    name:'BlogArea',
    mixins:[BlogMixin],
    data () {
        return {
           
        }
    },
  created() {
    this.getKurslar();
  },
  computed: {
    ...mapGetters('kurslar', ['kurslar']),
  },

  methods: {
    ...mapActions('kurslar', ['getKurslar']),
    getBadgeStyle(text) {
  const colors = [
    { bg: '#e3f2fd', text: '#2196f3' }, // Ko'k
    { bg: '#f3e5f5', text: '#9c27b0' }, // Binafsha
    { bg: '#e8f5e9', text: '#4caf50' }, // Yashil
    { bg: '#fff3e0', text: '#ff9800' }, // To'q sariq
    { bg: '#fce4ec', text: '#e91e63' }  // Pushti
  ];

  const index = text ? text.length % colors.length : 0;
  const selected = colors[index];

  return {
    backgroundColor: selected.bg,
    color: selected.text
  };
}
  }
};
</script>
